import { getTimeFromDate } from '@openeducation/oe-it-services';
import type { DayActivityHistory } from '@openeducation/oe-it-shared-types';
import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import { useTranslation } from 'react-i18next';

import { OEText } from '../../atoms';
import { CourseTypeIcon } from '../../atoms/course-type-icon/course-type-icon';

export const ActivityHistoryItem = (item: DayActivityHistory) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Icon>
        <CourseTypeIcon type={item.courseType} />
      </Icon>
      <Information>
        <Title>{t(`hr2.course.${item.courseType}`)}</Title>
        <StyledText>
          {getTimeFromDate(item.dateCompleted)}
          {' - '}
          {getTimeFromDate(item.dateStarted)}
        </StyledText>
        <StyledText>{item.courseTitle}</StyledText>
      </Information>
    </Container>
  );
};

const Icon = styled.View`
  margin-horizontal: 30px;
`;
const Information = styled.View`
  margin-bottom: 10px;
  flex: 1;
`;
const Container = styled.View`
  overflow: auto;
  border-top-color: ${({ theme }) => theme.color.border};
  border-top-width: 1px;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 10px;
`;

const StyledText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.dark2,
  fontSize: 16,
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
}))``;

const Title = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.black,
  fontSize: 20,
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
}))``;
